import { forwardRef, useImperativeHandle, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { Table } from '@core/design-system/table';
import { useManagerData } from './hook';

export const ManagerDataDialog = forwardRef((_, ref) => {
  const [openDialog, setOpenDialog] = useState(false);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  useImperativeHandle(ref, () => {
    return {
      handleCloseDialog,
      handleOpenDialog,
    };
  });

  const { columns, managerData, loading } = useManagerData();

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={openDialog}
      onClose={handleCloseDialog}
    >
      <DialogTitle>Dados alterados</DialogTitle>
      <DialogContent>
        <Stack>
          <Typography>
            A CVM é a fonte oficial dos dados das lâminas da Mais Retorno. Em
            algumas situações, os dados podem demorar a ser atualizados na CVM
            e, por este motivo, foram complementados e/ou editados a pedido do
            gestor responsável pelo fundo.
          </Typography>

          <Stack
            sx={{
              maxHeight: '400px',
              overflow: 'auto',
            }}
          >
            <Table
              withCard={false}
              columns={columns}
              data={managerData}
              loading={loading}
            />
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
});
